import React from 'react';
import { Box, FormControl, Select, MenuItem, Typography, Pagination, SelectChangeEvent } from '@mui/material';

interface TablePaginationProps {
  page: number;
  pageSize: number;
  totalItems: number;
  startIndex: number;
  endIndex: number;
  onPageChange: (event: React.ChangeEvent<unknown>, value: number) => void;
  onPageSizeChange: (event: SelectChangeEvent<number>) => void;
}

export const TablePagination: React.FC<TablePaginationProps> = ({
  page,
  pageSize,
  totalItems,
  startIndex,
  endIndex,
  onPageChange,
  onPageSizeChange
}) => {
  const pageCount = Math.ceil(totalItems / pageSize);

  return (
    <Box
      sx={{
        p: 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderTop: '1px solid',
        borderColor: 'divider',
        bgcolor: 'background.paper'
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography variant="body2" color="text.secondary">
            Records per page:
          </Typography>
          <FormControl size="small">
            <Select
              value={pageSize}
              onChange={onPageSizeChange}
              sx={{ minWidth: 80 }}
            >
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={25}>25</MenuItem>
              <MenuItem value={50}>50</MenuItem>
            </Select>
          </FormControl>
        </Box>

        <Typography variant="body2" color="text.secondary">
          {`${startIndex + 1}-${endIndex} of ${totalItems}`}
        </Typography>
      </Box>

      <Pagination 
        count={pageCount}
        page={page}
        onChange={onPageChange}
        color="primary"
        size="small"
        showFirstButton
        showLastButton
        siblingCount={1}
      />
    </Box>
  );
};